import React, { Fragment } from "react";
import { renderTextField, renderSelect } from "../../ReduxFormAdapters";
import { MenuItem, Typography } from "@material-ui/core";
import { connect } from "react-redux";
import ValidatedField from "../../Helpers/FieldValidator/ValidatedField";

const CompanyFields = (props) => {
    const { landlord, preferred } = props;
    const tenant = !landlord;
    return (
        <Fragment>
            {tenant &&
                <ValidatedField
                    name="creditRating"
                    component={renderSelect}
                    label="Credit Rating"
                >
                    <MenuItem value="">
                        Select your credit rating
                    </MenuItem>
                    <MenuItem value="aaa">AAA (Prime)</MenuItem>
                    <MenuItem value="aa">AA (High grade)</MenuItem>
                    <MenuItem value="a">A (Upper medium grade)</MenuItem>
                    <MenuItem value="bbb">BBB (Lower medium grade)</MenuItem>
                    <MenuItem value="bb">BB (Speculative)</MenuItem>
                    <MenuItem value="b">B (Highly speculative)</MenuItem>
                    <MenuItem value="c">C (Substantial risks)</MenuItem>
                    <MenuItem value="d">D (In default)</MenuItem>
                </ValidatedField>
            }

            {preferred &&
                <ValidatedField
                    multiple
                    name="creditRating"
                    component={renderSelect}
                    label="Credit rating"
                >
                    <MenuItem disabled value="">
                        Select preferable credit rating
                    </MenuItem>
                    <MenuItem value="aaa">AAA (Prime)</MenuItem>
                    <MenuItem value="aa">AA (High grade)</MenuItem>
                    <MenuItem value="a">A (Upper medium grade)</MenuItem>
                    <MenuItem value="bbb">BBB (Lower medium grade)</MenuItem>
                    <MenuItem value="bb">BB (Speculative)</MenuItem>
                    <MenuItem value="b">B (Highly speculative)</MenuItem>
                    <MenuItem value="c">C (Substantial risks)</MenuItem>
                    <MenuItem value="d">D (In default)</MenuItem>
                </ValidatedField>
            }

            {tenant &&
                <ValidatedField
                    name="companyName"
                    component={renderTextField}
                    type="text"
                    label="Company Name"
                />
            }

            {tenant &&
                <ValidatedField
                    name="operatingMargin"
                    component={renderSelect}
                    label="Turnover"
                >
                    <MenuItem value="">
                        Specify your turnover in Euro (€)
                    </MenuItem>
                    <MenuItem value="negative">0 - 250.000  €</MenuItem>
                    <MenuItem value="postitive">250.000 - 500.000 €</MenuItem>
                    <MenuItem value="higher">500.000 - 1 mil €</MenuItem>
                    <MenuItem value="postitive">1 - 3 mil €</MenuItem>
                    <MenuItem value="higher">3 mil  {">"}  €</MenuItem>
                </ValidatedField>
            }
            {preferred &&
                <ValidatedField
                    multiple
                    name="operatingMargin"
                    component={renderSelect}
                    label="Operating margin"
                >
                    <MenuItem value="">
                        Specify your turnover in euro(€)
                    </MenuItem>
                    <MenuItem value="negative">0 - 250.000  €</MenuItem>
                    <MenuItem value="postitive">250.000 - 500.000 €</MenuItem>
                    <MenuItem value="higher">500.000 - 1 mil €</MenuItem>
                    <MenuItem value="postitive">1 - 3 mil €</MenuItem>
                    <MenuItem value="higher">3 mil  {">"}  €</MenuItem>
                </ValidatedField>
            }
            {tenant &&
                <ValidatedField
                    name="userEmployee"
                    component={renderSelect}
                    label="No. of Employees"
                >
                    <MenuItem value="">
                        How many employee is the workspace for?
                    </MenuItem>
                    <MenuItem value={0}>1</MenuItem>
                    <MenuItem value={1}>2</MenuItem>
                    <MenuItem value={2}>3-4</MenuItem>
                    <MenuItem value={3}>5-9</MenuItem>
                    <MenuItem value={4}>10-19</MenuItem>
                    <MenuItem value={5}>20-49</MenuItem>
                    <MenuItem value={6}>50-99</MenuItem>
                    <MenuItem value={7}>100+</MenuItem>
                </ValidatedField>
            }
            {preferred &&
                <ValidatedField
                    multiple
                    name="employee"
                    component={renderSelect}
                    label="No. of Employees"
                >
                    <MenuItem value="">
                        How many employee is the workspace for?
                    </MenuItem>
                    <MenuItem value={0}>1</MenuItem>
                    <MenuItem value={1}>2</MenuItem>
                    <MenuItem value={2}>3-4</MenuItem>
                    <MenuItem value={3}>5-9</MenuItem>
                    <MenuItem value={4}>10-19</MenuItem>
                    <MenuItem value={5}>20-49</MenuItem>
                    <MenuItem value={6}>50-99</MenuItem>
                    <MenuItem value={7}>100+</MenuItem>
                </ValidatedField>
            }

            {tenant &&
                <Fragment>
                    <Typography
                        variant="body1"
                        color="secondary"
                    >
                        Please write a short description about your company (Max 300 characters):
                    </Typography>
                    <ValidatedField
                        name="description"
                        component={renderTextField}
                        multiline
                        margin="normal"
                        rowsMax="3"
                        type="text"
                    />
                </Fragment>
            }
        </Fragment>
    );
}

export default connect(
    (state, ownProps) => {
        return {
            ...ownProps
        }
    },
    dispatch => ({
        dispatch: dispatch
    })
)(CompanyFields);
